import { render, staticRenderFns } from "./AllAnnouncement.vue?vue&type=template&id=2f49047d&scoped=true&"
import script from "./AllAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AllAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./AllAnnouncement.vue?vue&type=style&index=0&id=2f49047d&prod&lang=scss&scoped=true&"
import style1 from "./AllAnnouncement.vue?vue&type=style&index=1&id=2f49047d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49047d",
  null
  
)

export default component.exports